import { mapState } from 'vuex'

const groupProductByProcessMixins = {
  computed: {
    ...mapState({
      groupProductByProcess: (state) => {
        const gProductByProcess = []
        state.product?.selectedProducts
          .forEach(p => {
            const productsByProcess = []
            state.coldChain.forEach(cChain => {
              const proccess = p.processes.find(x => x.productId === p.id && x.chainId === cChain.id)
              const coldChainName = cChain?.tooltiptext ?? cChain.description
              const id = coldChainName + '-' + p.label.trim() + '-' + proccess.temperature + '-' + proccess.recommendedTemperatureDegreeCelsiusStart + '-' + proccess.recommendedTemperatureDegreeCelsiusEnd
              productsByProcess.push({ processId: id, process: coldChainName, product: p.label.trim(), temperature: proccess.temperature, recommendedTemperatureDegreeCelsiusStart: proccess.recommendedTemperatureDegreeCelsiusStart, recommendedTemperatureDegreeCelsiusEnd: proccess.recommendedTemperatureDegreeCelsiusEnd })
            })

            gProductByProcess.push({ product: p.label.trim().toLowerCase(), processes: [...productsByProcess] })
          })
        return gProductByProcess
      }
    })
  }
}

export default groupProductByProcessMixins
